import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

import BaseIcon from '../../IconV1'

export const ListTextItem = styled.div`
  padding: 0.9375rem 0;
  display: flex;
  justify-content: space-between;
  font-size: 1.125rem;
  border-bottom: solid 1px ${color.SILVER};
  transition: background 200ms;
  align-items: center;

  ${p =>
    p.clickable &&
    `
    cursor: pointer;
    
    &:hover {
      background: #F1F5F9;
    }
  `};
`

export const Icon = styled(BaseIcon)`
  font-size: 1.5625rem;
  fill: #0e60c9;
`

export const Label = styled.div`
  color: ${color.MORTAR};
`

export const SubLabel = styled(Label)`
  font-size: 0.75rem;
  color: ${color.SILVER};
  text-align: left;
`

export const Value = styled.div`
  font-family: 'sidecarta-sans-bold', sans-serif;
  min-width: 6.5625rem;
  text-align: right;
`

export const SubValue = styled(Value)`
  font-size: 0.75rem;
  color: ${color.SILVER};
  text-align: right;
`
